import{jsx as t,Fragment as e,jsxs as o}from"react/jsx-runtime";import{useState as r,cloneElement as a}from"react";import i from"tailwind-styled-components";import m from"clsx";import n from"../../hooks/use-placement.js";import{getAnimationIn as s,getAnimationOut as l,getTransformOrigin as p}from"../utils.js";import d from"../animate/animate.js";const c=i.div`
  relative
`,u=i.div`
  absolute
  backdrop-blur-md
  bg-black/60
  max-w-md
  w-max
  p-2
  rounded
  shadow-md
  text-white
  text-sm
  z-10

  dark:bg-gray-800
  dark:text-gray-200
`,f=({children:i,placement:f="top",message:g,className:h,...x})=>{const[b,v]=r(!1),k=n(f,"tooltip");return g?o(c,{...x,children:[a(i,{onMouseEnter:t=>{t.preventDefault(),t.stopPropagation(),v(!0)},onMouseLeave:t=>{t.preventDefault(),t.stopPropagation(),v(!1)}}),t(d,{animationIn:s(f),animationOut:l(f),duration:150,transformOrigin:p(f),visible:b,children:t(u,{className:m(h,k),role:"tooltip",children:g})})]}):t(e,{children:i})};export{f as Tooltip,f as default};
